import { z } from 'zod';

export const notificationTypeSchema = z.enum([
  'payment_due',
  'payment_overdue',
  'group_invitation',
  'group_member_joined',
  'split_assigned',
  'split_paid',
  'period_auto_created',
  'subscription_renewed',
  'transaction_carried',
  // 🔁 Ay bitmeden sonraki aya kopyalanmış (erken taşınmış) kalemler kendi ayına geri alındı.
  'carry_reverted',
  'transaction_refunded',
  'installment_completed',
  'goal_threshold_reached',
  'goal_exceeded',
  'budget_threshold_exceeded',
  'appointment_reminder',
  'weekly_digest',
  'monthly_digest',
  'low_benefit_balance',
  'benefit_card_expiry',
  'benefit_load_missing',
  'credit_card_statement',
  'transfer_request',
  'transfer_accepted',
  'transfer_rejected',
  'billing_trial_ending',
  'billing_payment_failed',
  'billing_subscription_canceled',
  'import_review_pending',
  'system',
]);
export type NotificationType = z.infer<typeof notificationTypeSchema>;

export const listNotificationsQuerySchema = z.object({
  status: z.enum(['all', 'unread', 'read']).default('all'),
  page: z.coerce.number().int().positive().default(1),
  perPage: z.coerce.number().int().min(1).max(100).default(20),
});
export type ListNotificationsQuery = z.infer<typeof listNotificationsQuerySchema>;

export const markReadParamsSchema = z.object({
  id: z.string().uuid(),
});

export const pushTokenPlatformSchema = z.enum(['ios', 'android', 'web']);
export type PushTokenPlatform = z.infer<typeof pushTokenPlatformSchema>;

export const registerPushTokenSchema = z.object({
  // Web Push subscription JSON ~400-700 char olabilir; Expo token < 200.
  token: z.string().min(8).max(4096),
  platform: pushTokenPlatformSchema,
  deviceName: z.string().max(120).optional(),
  appVersion: z.string().max(32).optional(),
});
export type RegisterPushTokenInput = z.infer<typeof registerPushTokenSchema>;

export const revokePushTokenSchema = z.object({
  token: z.string().min(8).max(4096),
});
export type RevokePushTokenInput = z.infer<typeof revokePushTokenSchema>;
